import React from 'react';
import { Accommodation } from '../../../types';
import { getLocationLabel } from '../../../utils/translationHelpers';
import { getStayName } from '../utils';
import { Glass3dCard } from '../../ui/glass-3d-card';
import { StatefulButton } from '../../ui/stateful-button';
import { useProductCardCartActions } from '../useProductCardCartActions';
import { isStayReservable } from '../../../lib/stayReservation';

export const HomeAccommodationCard: React.FC<{
  stay: Accommodation;
  t: (key: string) => string;
  onBook?: (stay: Accommodation) => void;
}> = ({ stay, t, onBook }) => {
  const title = t(getStayName(stay.name)) || stay.name;
  const reservable = isStayReservable(stay);
  const cart = useProductCardCartActions(
    {
      type: 'accommodation',
      itemId: stay.id,
      itemName: getStayName(stay.name) || stay.name,
      itemPrice: stay.pricePerNight,
      taxeHebergementEnabled: stay.taxeHebergementEnabled !== false,
    },
    t
  );

  const meta = `${stay.capacity} ${t('common.persons') || 'guests'} · ${getLocationLabel(stay.location, t) || stay.location}`;
  const imageSrc = stay.images?.[0] || stay.imageUrls?.[0] || null;

  return (
    <Glass3dCard
      title={title}
      text={stay.description}
      meta={meta}
      imageSrc={imageSrc}
      isAvailable={stay.isAvailable !== false}
      availableLabel={t('common.available') || 'Available'}
      unavailableLabel={t('common.unavailable') || 'Unavailable'}
      viewMoreLabel={t('common.viewDetails') || 'View more'}
      viewMoreHref={`/webdesigned/stays/${stay.id}`}
      isLiked={reservable ? cart.isLiked : false}
      isFavorite={reservable ? cart.isFavorite : false}
      isInCart={reservable ? cart.isInCart : false}
      onLike={reservable ? cart.onLike : undefined}
      onFavorite={reservable ? cart.onFavorite : undefined}
      onCart={reservable ? cart.onCart : undefined}
      likeTitle={cart.likeTitle}
      favoriteTitle={cart.favoriteTitle}
      cartTitle={cart.cartTitle}
      primaryAction={
        reservable ? (
          <StatefulButton
            className="min-w-0 bg-[#1e5c34] px-3 py-1.5 text-xs font-semibold hover:ring-[#1e5c34]"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onBook?.(stay);
            }}
          >
            {t('common.quickBook')}
          </StatefulButton>
        ) : undefined
      }
    />
  );
};
